import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navigation from './Navigation';
import StarField from '../common/StarField';
import Footer from './Footer';

interface LayoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const isZh = i18n.language.startsWith('zh');

  return (
    <div className="min-h-screen relative">
      <a href="#main-content" className="fixed left-4 top-3 z-[100] -translate-y-20 rounded-full bg-tarot-gold px-4 py-2 text-sm font-semibold text-tarot-ink transition-transform focus:translate-y-0">
        {isZh ? '跳至主要内容' : 'Skip to content'}
      </a>
      <StarField />
      <Navigation />
      <main
        id="main-content"
        tabIndex={-1}
        aria-label={isZh ? '主要内容' : 'Main content'}
        className="relative z-10 min-h-[calc(100vh-4.5rem)] focus:outline-none"
      >
        {children || <Outlet />}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
